import { render, staticRenderFns } from "./TipoOtroPago.vue?vue&type=template&id=14653bd0&scoped=true"
import script from "./TipoOtroPago.vue?vue&type=script&lang=js"
export * from "./TipoOtroPago.vue?vue&type=script&lang=js"
import style0 from "./TipoOtroPago.vue?vue&type=style&index=0&id=14653bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14653bd0",
  null
  
)

export default component.exports